import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { NavigationItem, NavigationItemIconPosition } from '@stylehaven/components';

import { OverviewOptions } from '../../state/overview/overview-options.entity';

@Injectable()
export class BackToSearchNavigationCreator {
    constructor(private readonly translateService: TranslateService) {}

    public getNavigationItem(viewOptions: OverviewOptions | undefined): NavigationItem | undefined {
        if (!viewOptions) {
            return undefined;
        }

        const queryParams = viewOptions.queryParams ? { ...viewOptions.queryParams } : {};

        return {
            label: viewOptions.backToSearchLabel || this.translateService.instant('navigation.back-to.search'),
            navigationLink: {
                route: viewOptions.overview,
                extras: {
                    queryParams: queryParams
                }
            },
            icon: 'arrow-left',
            iconPosition: NavigationItemIconPosition.Start
        };
    }
}
